__turbopack_context__.v({
  "skip-links-bar": "skip-links-component-module-scss-module__0dCfKq__skip-links-bar",
  "skip-links-content": "skip-links-component-module-scss-module__0dCfKq__skip-links-content",
});
